/**
 * @generated SignedSource<<976392901409058b2c1b303c0f17a2ab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "proposedValue"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RosterLoadMutationGroup",
    "kind": "LinkedField",
    "name": "rosterLoad",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "id"
              },
              {
                "kind": "Variable",
                "name": "proposedValue",
                "variableName": "proposedValue"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "RosterLoadPropertyModifyPayload",
        "kind": "LinkedField",
        "name": "modifyRosterLoadProperty",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RosterLoadProperty",
            "kind": "LinkedField",
            "name": "property",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "proposedValue",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "usePropertyFieldMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePropertyFieldMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "352cfc93877b6e23babdfba245b1eb70",
    "id": null,
    "metadata": {},
    "name": "usePropertyFieldMutation",
    "operationKind": "mutation",
    "text": "mutation usePropertyFieldMutation(\n  $id: ID!\n  $proposedValue: StringInput\n) {\n  rosterLoad {\n    modifyRosterLoadProperty(input: {id: $id, proposedValue: $proposedValue}) {\n      property {\n        id\n        proposedValue\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "1e4471099189caf368eb8fdac675b894";

export default node;
